import { render, staticRenderFns } from "./New_Services.vue?vue&type=template&id=d5826c1c&scoped=true"
import script from "./New_Services.vue?vue&type=script&lang=js"
export * from "./New_Services.vue?vue&type=script&lang=js"
import style0 from "./New_Services.vue?vue&type=style&index=0&id=d5826c1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5826c1c",
  null
  
)

export default component.exports